import { useLazyLoadQuery } from "react-relay"
import { chVerifyMedicationQuery } from "@/modules/patients/detail/medication/ch/services/__generated__/chVerifyMedicationQuery.graphql"
import { ch_VerifyMedicationQuery as chQuery } from "@/modules/patients/detail/medication/ch/services/chVerifyMedicationQuery"
import { deVerifyMedicationQuery } from "@/modules/patients/detail/medication/de/services/__generated__/deVerifyMedicationQuery.graphql"
import { de_VerifyMedicationQuery as deQuery } from "@/modules/patients/detail/medication/de/services/deVerifyMedicationQuery"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { Country } from "@/types/__generated__/union-types"

const getQueryByCountry = (country: Country) => {
  switch (country) {
    case "DE":
      return deQuery
    case "CH":
      return chQuery
  }
}

export const useVerifyMedicationQuery = (appointmentId: string, patientId: string, skip: boolean) => {
  const country = useCountryParam()
  const query = getQueryByCountry(country)
  const data = useLazyLoadQuery<chVerifyMedicationQuery | deVerifyMedicationQuery>(query, {
    appointmentId,
    patientId,
    skip,
  })

  return data.medicationVerification?.result
}
